import * as Sentry from "@sentry/react"
import { setVendorClient } from "@sgftech/vendor-panel-core/lib/client"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app.js"
import { backendUrl, publishableApiKey } from "./lib/client"

/**
 * Install the vendor client before the first render. The hooks in
 * @sgftech/vendor-panel-core read it from module scope and throw if it is
 * missing, so this must run ahead of anything that renders a vendor hook —
 * hence here rather than inside a module whose import order is incidental.
 *
 * This is the one place the web platform bindings are supplied; the mobile app
 * calls the same function with AsyncStorage and a router redirect.
 */
setVendorClient({
  baseUrl: backendUrl,
  publishableKey: publishableApiKey,
  tokenStorage: {
    getItem: (k: string) => window.localStorage.getItem(k),
    setItem: (k: string, v: string) => window.localStorage.setItem(k, v),
    removeItem: (k: string) => window.localStorage.removeItem(k),
  },
  onUnauthorized: () => {
    window.location.href = "/login?reason=Unauthorized"
  },
})

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
